var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main"
    }
  }, [_c('bs-navbar', {
    staticClass: "bd-navbar",
    attrs: {
      "type": "dark"
    }
  }, [_c('template', {
    slot: "brand"
  }, [_vm._v("Bootstrap")]), _vm._v(" "), _c('bs-navbar-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('bs-navbar-item', [_vm._v("Link")]), _vm._v(" "), _c('bs-navbar-item', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Disabled")])], 2), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row flex-xl-nowrap"
  }, [_c('div', {
    staticClass: "col-12 col-md-3 col-xl-2 bd-sidebar"
  }, [_c('sidebar-nav')], 1), _vm._v(" "), _c('main', {
    staticClass: "col-12 col-md-9 col-xl-8 py-md-3 pl-md-5 bd-content"
  }, [_c('router-view')], 1)])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d7020d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/views/BaseView.vue
// module id = 102
// module chunks = 19